import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { FormattedMessage } from 'react-intl';

import { GameplayTierStars } from '@sorare/core/src/components/card/GameplayTierStars';
import { FILTERS } from '@sorare/core/src/lib/filters';
import {
  isGameplayTier,
  sortByGameplayTier,
} from '@sorare/core/src/lib/gameplayTiers';

import { makeFilter } from '#src/searchCards/RefineList/index.tsx';

export const RefineGameplayTier = ({
  hideTitle,
}: { hideTitle?: boolean } = {}) =>
  makeFilter(FILTERS.gameplayTier, {
    formatOption: () => '',
    transformItems: (items: RefinementListItem[]) => [
      ...items.sort((a, b) => sortByGameplayTier(a.value, b.value)),
    ],
    renderBefore: (o: string) =>
      isGameplayTier(o) ? (
        <GameplayTierStars gameplayTier={o} />
      ) : (
        <FormattedMessage defaultMessage="Unknown" />
      ),
    hideTitle,
  });
